<template>
  <v-menu
    ref="menu"
    left
    :close-on-click="false"
    :close-on-content-click="false"
    max-width="300px"
    min-width="300px"
  >
    <template #activator="{ on, attrs }">
      <v-btn v-bind="attrs" :block="$vuetify.breakpoint.mdAndDown" v-on="on">
        <v-icon class="mr-2">mdi-calendar</v-icon>
        <span>{{ filterLabel || 'Date Filters' }}</span>
      </v-btn>
    </template>
    <v-card>
      <v-card-title>
        Filter by Date
        <v-spacer />
        <v-btn icon @click="$refs.menu.save()"><v-icon>mdi-close</v-icon></v-btn>
      </v-card-title>
      <v-divider />
      <v-card-text>
        <v-select
          :value="timePeriod"
          label="Select time period"
          :items="timePeriodItems"
          clearable
          @change="$emit('update:timePeriod', $event)"
        />
        <v-row v-if="timePeriod === 'date_range'">
          <v-col cols="6">
            <CommonDatePicker
              label="From"
              left
              :enter-date="dateFrom"
              :hide-details="false"
              @updateDate="$emit('update:dateFrom', $event)"
            />
          </v-col>
          <v-col cols="6">
            <CommonDatePicker
              label="To"
              left
              :enter-date="dateTo"
              :hide-details="false"
              @updateDate="$emit('update:dateTo', $event)"
            />
          </v-col>
        </v-row>
        <v-btn-toggle
          v-if="timePeriod"
          :value="dateToggle"
          mandatory
          @change="$emit('update:dateToggle', $event)"
        >
          <v-btn value="paid">
            Paid Date
          </v-btn>
          <v-btn value="due">
            Due Date
          </v-btn>
        </v-btn-toggle>
      </v-card-text>
      <v-card-actions>
        <v-btn class="cancel" outlined @click="$emit('click:clear')">Clear</v-btn>
        <v-spacer />
        <v-btn class="primary" data-track="report.open-balances-dates.apply" @click="applyHandler">Apply</v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script lang="ts">
import Vue from 'vue';

import { ITextValue } from '@/types/common';

import CommonDatePicker from '@/components/common-components/pickers/CommonDatePicker.vue';

interface IData {
  timePeriodItems?: ITextValue<string>[];
}

export default Vue.extend({
  name: 'OpenBalancesDateFilter',

  components: { CommonDatePicker },

  props: {
    filterLabel: {
      type: String,
      default: '',
    },
    timePeriod: {
      type: String,
      default: '',
    },
    dateFrom: {
      type: String,
      default: '',
    },
    dateTo: {
      type: String,
      default: '',
    },
    dateToggle: {
      type: String,
      default: 'paid',
    },
  },

  data: (): IData => ({}),

  created () {
    this.timePeriodItems = [
      { text: 'This Calendar Month', value: 'month' },
      { text: 'This Calendar Year', value: 'year' },
      { text: 'Date Range', value: 'date_range' },
    ];
  },

  methods: {
    applyHandler () {
      (this.$refs.menu as any).save();
      this.$emit('click:apply');
    }
  }
})
</script>
